import apiClient from './axios';

const escalationHistoryApi = {
  getAll: async (page = 1, pageSize = 10, search = '', escalatedFrom = '') => {
    const response = await apiClient.get('/escalation-history/', {
      params: { page, page_size: pageSize, search, escalated_from: escalatedFrom },
    });
    return response.data;
  },
};

export default escalationHistoryApi;